<template>
<div class="home-container">
  <m-header :login-state="true" ></m-header>
  <div class="home-center">
    <img src="~assets/bg_img.png" alt="" class="bg-img">
    <div class="middle-container">
      <div class="middle-left">
        <img src="~assets/logo.png" alt="" class="logo">
        <div class="middle-txt">
          <h1 class="middle-title">一键计量，足不出户</h1>
          <ul class="icon-container">
            <li>
              <img src="~assets/list_icon1.png" alt="" class="list-icon">
                <span class="icon-txt">费用公开透明</span>
            </li>
            <li>
              <img src="~assets/list_icon2.png" alt="" class="list-icon">
              <span class="icon-txt">在线查阅证书</span>
            </li>
            <li>
              <img src="~assets/list_icon3.png" alt="" class="list-icon">
              <span class="icon-txt">24小时内免费取件</span>
            </li>
            <li>
              <img src="~assets/list_icon4.png" alt="" class="list-icon">
              <span class="icon-txt">全国快递送检</span>
            </li>
          </ul>
          <img class="qr-code" src="~assets/qr_code.jpg" alt="">
          <p class="add-txt">请使用微信扫描</p>
        </div>
      </div>
      <img src="~assets/phone.png" alt="" class="middle-img">
    </div>
  </div>
  <!-- 图片 banner -->
  <ul class="banner">
    <li class="banner-list">
      <img src="~assets/list1.png" alt="">
      <span class="banner-txt">
        费用公开透明
      </span>
    </li>
    <li class="banner-list">
      <img src="~assets/list2.png" alt="">
      <span class="banner-txt">
        在线查阅证书
      </span>
    </li>
    <li class="banner-list">
      <img src="~assets/list3.png" alt="">
      <span class="banner-txt">
        24小时内免费取件
      </span>
    </li>
    <li class="banner-list">
      <img src="~assets/list4.png" alt="">
      <span class="banner-txt">
        全国快递送检
      </span>
    </li>
  </ul>
  <!-- 合作机构 start -->
  <!-- 合作机构 -->
  <div class="agency-container">
    <h2 class="agency-title">合作机构</h2>
    <ul class="agency-list">
      <li class="list-img">
        <a href="http://www.simt.com.cn" >
          <img src="~assets/1simt.png" target="_blank" alt="" class="agency-img">
        </a>
      </li>
      <li class="list-img">
        <a href="http://www.sqi.com.cn/SQI_Web_new/index.html">
          <img src="~assets/2AQL.png" target="_blank" alt="" class="agency-img">
        </a>
      </li>
      <li class="list-img">
        <a href="http://www.nimtt.com/">
          <img src="~assets/3nt.png" target="_blank" alt="" class="agency-img">
        </a>
      </li>
      <li class="list-img">
        <a href="http://www.nimtt.com.cn/">
          <img src="~assets/4accu-tech.png" target="_blank" alt="" class="agency-img">
        </a>
      </li>
      <li class="list-img">
        <a href="http://www.setri.com.cn/cn/index/">
          <img src="~assets/5setrt.png" alt="" target="_blank" class="agency-img">
        </a>
      </li>
      <li class="list-img">
        <a href="http://www.sitiias.com.cn/">
          <img src="~assets/6sitiia.png" target="_blank" alt="" class="agency-img">
        </a>
      </li>
    </ul>
  </div>
  <!-- 合作机构 end -->
  <foot></foot>
</div>
</template>

<script type='text/ecmascript-6'>
import MHeader from 'components/header/header'
import Foot from 'components/footer/footer'
export default {
  created () {
    console.log(this.$route)
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      // 移动端的操作
      this.$router.replace('/addHome')
    } else {
      console.log('diandao')
    }
  },
  components: {
    MHeader,
    Foot
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
.home-container
  .home-center
    position:relative;
    .bg-img
      width:100%;
      height:880px;
    .middle-container
      position:absolute;
      top:0px;
      left:0px;
      right:0px;
      bottom:0px;
      display:flex;
      justify-content:center;
      align-items:center;
      .middle-left
        .logo
          width: 91px;
          height: 98px
        .middle-txt
          margin-top: 45px;
          .middle-title
            font-size: 45px;
            color: #fff;
          .icon-container
            margin-top: 45px;
            list-style: none;
            overflow: hidden;
            li
              float: left;
              color: #fff;
              font-size: 20px;
              height: 30px;
              margin-bottom: 24px;
              width: 50%;
              .list-icon
                vertical-align: middle;
                margin-right: 10px;
                width: 30px;
                height: 30px;
              .icon-txt
                display: inline-block;
                line-height: 30px
          .qr-code
            margin-top: 78px;
            width: 200px;
            height: 200px;
            border-radius:20px;
          .add-txt
            color:#fff;
            font-size:16px;
            margin-top:20px;
            width:200px;
            text-align:center;
      .middle-img
        height:700px;
  .banner
    width:100%;
    display:flex;
    list-style: none;
    .banner-list
      flex:1;
      margin-right:3px;
      margin-top:3px;
      position:relative;
      &:last-child
        margin-right:0px
      img
        width:100%;
      .banner-txt
        position:absolute;
        top:0px;
        bottom:0px;
        left:0px;
        right:0px;
        display:flex;
        justify-content: center;
        align-items: center;
        font-size:24px;
        color:#fff;
  .agency-container
    min-width:1200px;
    .agency-title
      padding:85px 0px 70px 0px;
      text-align:center;
      color:#1e499f;
      font-size:24px;
    .agency-list
      width:1200px;
      display:flex;
      justify-content: space-around;
      list-style:none;
      flex-wrap:wrap;
      margin:0px auto;
      .list-img
        flex:1;
        margin-bottom:10px;
        .agency-img
          width:382px;
          height:195px;
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue